import providerInstance from "../api-provider";
import billingInstance from "../api-billing";
import handleError from "../handleError";

// export const getProviderAppointments = async (appointmentData) => {
//   try {
//     let response = await instance({
//       url: "/appointment/getProviderAppointments",
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: appointmentData,
//     });
//     return response.data;
//   } catch (error) {
//     return "ERROR";
//   }
// };

// export const getProviderListByAdmin = async (payload) => {
//   try {
//     let response = await instance({
//       url: "/provider/getProviderListByAdmin",
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: payload,
//     });
//     return response.data;
//   } catch (error) {
//     return "ERROR";
//   }
// };

export const changeAppointmentStatus = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/appointment/changeAppointmentStatus",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    return "ERROR";
  }
};

export const rescheduleAppointment = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/appointment/rescheduleAppointment",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    return "ERROR";
  }
};

export const createAppointment = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/appointment/createAppointment",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("error: ", error);
    return "ERROR";
  }
};

export const getAppointments = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/getAppointments",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAppointmentEligibilityList = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/getAppointmentEligibilityList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateAppointmentEligibilityStatus = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/updateAppointmentEligibilityStatus",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAppointmentsCount = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/getAppointmentsCount",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getRemindersByPatient = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/getRemindersByPatient",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const createAppointmentProvider = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/createAppointment",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateAppointmentProvider = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/updateAppointment",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const addChargeEntry = async (payload, token) => {
  try {
    let response = await billingInstance({
      url: "/addChargeEntry",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const printEncounterForms = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/printEncounterForms",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
      // responseType: "arraybuffer",
    });
    // const url = window.URL.createObjectURL(
    //   new Blob([response.data], { type: "application/pdf" }),
    // );
    // window.open(
    //   url,
    //   "_blank",
    //   "location=yes,height=570,width=520,scrollbars=yes,status=yes",
    // );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getEncounterFormsBatchList = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/getEncounterFormsBatchList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getEncounterFormBatchFile = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/getEncounterFormBatchFile",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
      responseType: "arraybuffer",
    });
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/pdf" })
    );
    window.open(
      url,
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes"
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const initiateEncounterFormsBatch = async (payload, token) => {
  try {
    let response = await providerInstance({
      url: "/provider/initiateEncounterFormsBatch",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
